// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__3KIZ1","text":"style_text__3Yhhp","desktop":"style_desktop__2_xMx","mobile":"style_mobile__3YNQi"};